
import {
	Checkbox,
	Label,
	LayoutBox
} from '@bamboohr/fabric';
import {
	Component,
	Fragment,
} from 'react';
import './optional-checkbox.styl';

export class OptionalCheckbox extends Component {
	constructor(props) {
		super(props);
		const { data } = props;

		this.state = {
			checked: data.checked
		};
	}


	_handleCheckBoxChange = (param) => {
		this.setState({
			checked: param.checked,
		});
	};


	_renderCheckbox = () => {
		const {
			biId = '',
			id,
			data,
			viewOnly,
			isUnemploymentField,
			required
		} = this.props;
		const {
			checked,
		} = this.state;
		const namePrefix = isUnemploymentField ? 'uiState' : 'state';

		return (
			<Fragment>
				<Checkbox
					biId={biId}
					checked={ checked }
					disabled={ viewOnly }
					id={ `checkbox${ id }` }
					label={ data.label }
					name={ `${ namePrefix }[optional][${ id }]` }
					onChange={ this._handleCheckBoxChange }
					required={required}
					value={ checked ? 'on' : 'off' }
				/>
				<input
					name={ `${ namePrefix }[optional][${ id }]` }
					required={required}
					type="hidden"
					value={ checked ? 'on' : 'off' }
				/>
			</Fragment>
		);
	};


	render() {
		const {
			data,
		} = this.props;

		return <LayoutBox>
			{ data.firstCheckbox ? (
				<Label>
					{ $.__('Select all that apply') }
				</Label>
			) : null }
			<fieldset className="fab-CheckboxGroup">
				{ this._renderCheckbox() }
			</fieldset>
		</LayoutBox>
	}

}
